import type { JSX } from "react";
import { toast } from "sonner";
import { friendlyError } from "../../shared/http.js";
import { usePrefs } from "../cook-sessions/usePrefs.js";

export function Preferences(): JSX.Element {
  const { mealPlanDailyEmail, patchPrefs } = usePrefs();

  async function onToggleDailyEmail(checked: boolean): Promise<void> {
    try {
      await patchPrefs({ mealPlanDailyEmail: checked });
    } catch (e) {
      toast.error(friendlyError(e));
    }
  }

  return (
    <>
      <h1 className="text-2xl font-semibold tracking-tight text-zinc-50">Preferences</h1>

      <section className="pt-6">
        <h2 className="text-zinc-50 font-medium mb-1">Email</h2>
        <label className="flex items-center gap-3 text-sm text-zinc-200 max-w-md">
          <input
            type="checkbox"
            checked={mealPlanDailyEmail}
            onChange={(e) => void onToggleDailyEmail(e.target.checked)}
            className="h-4 w-4 rounded border-zinc-600 bg-zinc-800 text-emerald-600 focus:ring-emerald-600"
          />
          Daily meal-plan email
        </label>
        <p className="text-zinc-500 text-xs mt-2 max-w-md">
          A morning summary of today&apos;s meals, prep tasks, and upcoming leftovers.
        </p>
      </section>
    </>
  );
}
